<template>
  <div class="personal container">
    <div class="page_content">
        <div class="page_width ">
          
            <div class="grid personal_content">
                <div class="personal_group grid_md_3 grid_sm_12">
                    <div class="flex_col_content">
                        <div class="avatar ">
                            <img src="../../assets/image/avatar.png" alt="">
                        </div>
                        <div class="personal_info flex_sb">
                            <div class="info_label">Nickname</div>
                            <div class="info_value">{{nickName}}</div>
                        </div>
                        <div class="personal_info flex_sb">
                            <div class="info_label">Email</div>
                            <div class="info_value">{{ userInfo.email }}</div>
                        </div> 
                        <div class="personal_info flex_sb">
                            <div class="info_label">coins</div>
                            <div class="info_value flex">{{ userInfo.coins }}
                                <i class="flex_content" style="margin-left:6px;"><svg t="1727340443326" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16427" width="16" height="16"><path d="M627.297444 73.795726l-252.991991 12.929474-150.698211 114.16925L109.437993 398.642233v228.338498l114.169249 197.74676 143.422504 114.170272 281.55656 11.306511 184.30768-100.281961 128.715547-222.941582V398.642233L847.440283 200.89445z" fill="#D8AB15" p-id="16428"></path><path d="M605.815177 85.913718H377.476679L179.729919 200.082968 65.559647 397.830751v228.338498l114.170272 197.74676 197.74676 114.169249h228.338498l197.74676-114.169249 114.170273-197.74676V397.830751l-114.170273-197.747783z" fill="#F4DB33" p-id="16429"></path><path d="M321.538669 291.831578l478.853065-90.937128-193.627952 383.194402z" fill="#F4EE6D" p-id="16430"></path><path d="M372.082832 938.897763l-50.544163-647.066185L62.389444 626.980731l110.559025 191.495382z" fill="#F4D533" p-id="16431"></path><path d="M608.986403 584.088852L374.305453 938.897763h234.68095z" fill="#F4D835" p-id="16432"></path><path d="M914.560984 626.980731l-305.574581-42.891879v354.808911l191.405331-114.170272z" fill="#F4D735" p-id="16433"></path><path d="M323.76129 291.831578l285.225113 292.257274-234.68095 354.808911z" fill="#F3E044" p-id="16434"></path><path d="M330.289983 291.831578l44.01547-205.106378-197.74676 114.16925L62.389444 398.642233v228.338498z" fill="#F4D12E" p-id="16435"></path><path d="M800.391734 200.89445L914.560984 398.642233v228.338498l-305.574581-42.891879z" fill="#F4DF44" p-id="16436"></path><path d="M585.425801 861.990163H397.866055L235.435639 768.211313 141.655765 605.779873V418.220127l93.779874-162.430416 162.430416-93.779874h187.559746l162.43144 93.779874 93.77885 162.430416V605.779873l-93.77885 162.43144-162.43144 93.77885z m-181.092451-24.136724h174.624133l151.229306-87.311554 87.311555-151.229307V424.687422l-87.311555-151.229307-151.229306-87.312578H404.33335l-151.229307 87.312578-87.312578 151.229307v174.624133l87.312578 151.229306 151.229307 87.312578z" fill="#B16A23" opacity=".29" p-id="16437"></path><path d="M367.029746 938.897763l281.55656 11.306511 184.30768-100.281961-32.502252-25.194822-191.405331 114.170272z" fill="#BE8516" p-id="16438"></path><path d="M627.297444 73.795726l-21.482267 12.117992 197.74676 114.16925 43.878346 0.811482z" fill="#D2BD33" p-id="16439"></path><path d="M494.090607 643.732254l144.024207-151.486157c2.238994-2.612501 3.731998-7.462972 3.731998-12.685927 0-4.477988-1.119497-8.954953-3.359514-11.94096h-0.373507l-72.384587-76.861552c-2.238994-2.238994-3.731998-3.731998-5.223979-4.477988-1.119497-0.74599-2.238994-1.119497-3.731997-1.119497H412.004053c-0.74599 0-1.865487 0-2.986007 0.373507-1.490957 0.74599-3.357468 1.865487-5.969969 4.851495l-72.384587 77.235058c-2.612501 2.612501-3.731998 6.715959-3.731998 11.19497 0 4.850471 1.493004 9.700943 4.479012 13.804401L475.061205 643.7343c4.850471 5.596462 7.835456 5.596462 9.328459 5.596462 1.864464-0.002047 4.476965-0.002047 9.700943-5.598508z m0 0" fill="#F4D033" p-id="16440"></path><path d="M645.203256 498.961032L501.179049 650.448212c-8.208962 8.580422-13.431917 8.580422-16.790408 8.580423-2.986007 0-8.582469 0-16.417925-8.580423L323.947532 498.961032s0-0.37146-0.373507-0.37146c-4.103458-5.970992-6.343475-13.059434-6.343475-19.775392s2.238994-13.43294 6.343475-17.909905l72.38561-77.236082c3.730974-3.731998 6.715959-5.969968 9.327436-7.089465 2.986007-1.119497 5.223978-1.119497 6.715959-1.119497h145.143705c3.358491 0 5.596462 0.74599 8.208962 2.238994 2.611477 1.490957 4.476965 3.357468 7.461949 6.343475l72.384587 76.862575c0.373507 0 0.373507 0 0.373507 0.37146 4.103458 4.851495 5.969968 11.567453 5.969968 18.284435 0 7.460925-2.237971 14.923898-5.969968 19.029402-0.372483-0.001023-0.372483 0.37146-0.372484 0.37146zM494.090607 643.732254l144.024207-151.486157c2.238994-2.612501 3.731998-7.462972 3.731998-12.685927 0-4.477988-1.119497-8.954953-3.359514-11.94096h-0.373507l-72.384587-76.861552c-2.238994-2.238994-3.731998-3.731998-5.223979-4.477988-1.119497-0.74599-2.238994-1.119497-3.731997-1.119497H412.004053c-0.74599 0-1.865487 0-2.986007 0.373507-1.490957 0.74599-3.357468 1.865487-5.969969 4.851495l-72.384587 77.235058c-2.612501 2.612501-3.731998 6.715959-3.731998 11.19497 0 4.850471 1.493004 9.700943 4.479012 13.804401L475.061205 643.7343c4.850471 5.596462 7.835456 5.596462 9.328459 5.596462 1.864464-0.002047 4.476965-0.002047 9.700943-5.598508z m0 0" fill="#ECBF1D" p-id="16441"></path><path d="M417.600515 470.977701c-1.493004-1.865487-1.493004-5.222955 0.74599-6.715958 1.866511-1.866511 4.850471-1.493004 6.716982 0.373506l59.326177 69.774133 60.818157-69.774133c1.865487-1.865487 4.850471-2.238994 7.089465-0.373506 1.866511 1.866511 1.866511 4.850471 0.373507 6.715958l-64.550155 73.877591-0.74599 0.747014a4.793166 4.793166 0 0 1-6.716982-0.747014l-63.057151-73.877591z m0 0" fill="#F5EC67" p-id="16442"></path><path d="M627.297444 73.795726L377.476679 85.913718h228.338498z" fill="#BE8516" p-id="16443"></path></svg></i>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="game_group grid_md_9 grid_sm_12">
                    <div class="group_title">Your Games</div>
                    <div class="md_line"></div>
                    <div class="game_list flex_warp " v-if="userGames.length>0" >
                        <div class="cate_tab pointer" v-for="(item,index) in userGames" :key="index">  
                            <div class="cate_tab_image" @click="toGame(item.url)">
                                <el-image :src="item.image" > </el-image>
                            </div>   
                            <div class="cate_tab_title">{{ item.name }}</div>
                            </div>
                    </div>
                    <div class="game_empty" v-else>
                        <div class="flex_col_content">
                            <svg t="1728527885646" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2929" width="128" height="128"><path d="M855.6 427.2H168.5c-12.7 0-24.4 6.9-30.6 18L4.4 684.7C1.5 689.9 0 695.8 0 701.8v287.1c0 19.4 15.7 35.1 35.1 35.1H989c19.4 0 35.1-15.7 35.1-35.1V701.8c0-6-1.5-11.8-4.4-17.1L886.2 445.2c-6.2-11.1-17.9-18-30.6-18zM673.4 695.6c-16.5 0-30.8 11.5-34.3 27.7-12.7 58.5-64.8 102.3-127.2 102.3s-114.5-43.8-127.2-102.3c-3.5-16.1-17.8-27.7-34.3-27.7H119c-26.4 0-43.3-28-31.1-51.4l81.7-155.8c6.1-11.6 18-18.8 31.1-18.8h622.4c13 0 25 7.2 31.1 18.8l81.7 155.8c12.2 23.4-4.7 51.4-31.1 51.4H673.4zM819.9 209.5c-1-1.8-2.1-3.7-3.2-5.5-9.8-16.6-31.1-22.2-47.8-12.6L648.5 261c-17 9.8-22.7 31.6-12.6 48.4 0.9 1.4 1.7 2.9 2.5 4.4 9.5 17 31.2 22.8 48 13L807 257.3c16.7-9.7 22.4-31 12.9-47.8zM375.4 261.1L255 191.6c-16.7-9.6-38-4-47.8 12.6-1.1 1.8-2.1 3.6-3.2 5.5-9.5 16.8-3.8 38.1 12.9 47.8L337.3 327c16.9 9.7 38.6 4 48-13.1 0.8-1.5 1.7-2.9 2.5-4.4 10.2-16.8 4.5-38.6-12.4-48.4zM512 239.3h2.5c19.5 0.3 35.5-15.5 35.5-35.1v-139c0-19.3-15.6-34.9-34.8-35.1h-6.4C489.6 30.3 474 46 474 65.2v139c0 19.5 15.9 35.4 35.5 35.1h2.5z" p-id="2930" fill="#cdcdcd"></path></svg>
                            <div class="empty_text">You haven't purchased any games yet</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
data(){
    return{
        nickName:"TJD19-7443290"
    }
},
created(){
   
},
methods:{
    toGame(url){ 
      window.open(url, '_blank');
    },
},
computed:{
    userInfo(){ return this.$store.state.userInfo },
    userGames(){ return this.$store.state.userGames}
}
}
</script>

<style lang="scss" scoped>
.personal{
    .page_content{
        width:100%;
        height: 100vh;
        background-image: url(../../assets/image/bg-2.webp);
        background-size: 100% auto;
        background-repeat:no-repeat;
        background-position: center;
        .personal_content{ 
            padding-top:200px;
            grid-column-gap:30px;
            grid-row-gap:30px;
        }
     
    }
    .personal_group{
        max-height: 300px;
        padding: 20px 20px 60px;
        border-radius: 8px;
        background-color:rgba($color: #000000, $alpha: .4);
        .avatar{
            width:80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            margin-bottom:40px;
        }
        .personal_info{
            width: 100%;
            color:#fff;
            margin-top:14px;
            font-size: 14px;
            // .info_label{
            //     width: 40%;
            //     margin-right:20px;
            //     text-align: right;
            // }
        }
    }
    .game_group{
        padding:20px;
        background-color:rgba($color: #000000, $alpha: .4);
        border-radius: 8px;
        .group_title{
            color:#fff;
            font-size: 26px;
            font-weight: 600;
            
        }
        .game_list{
            padding-top:20px;
            .cate_tab{
                
                transition: all 0.2s ease-out;
                padding:0 10px;
               
                position: relative;
                .cate_tab_image{
                    height: 150px;
                    width:150px;
                    border-radius: 6px;
                    overflow: hidden;
                }
                .cate_tab_title{
                    color:#fff;
                    margin-top:10px;
                }
            }
        }
        .game_empty{
            margin-top:20px;
            .empty_text{
                color:#fff;
                font-size: 20px;
                margin-top:20px;
                font-weight: 600;
            }
        }

    }
}

</style>